export const iosStoreUrl = (iosStoreId: string) =>
  `https://itunes.apple.com/jp/app/id${iosStoreId}`

export const androidStoreUrl = (androidAppId: string) =>
  `https://play.google.com/store/apps/details?id=${androidAppId}`
